import { render, staticRenderFns } from "./MeitiType2.vue?vue&type=template&id=61eaa01a&"
import script from "./MeitiType2.vue?vue&type=script&lang=js&"
export * from "./MeitiType2.vue?vue&type=script&lang=js&"
import style0 from "./MeitiType2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports